export const getBasePath = (): string => {
  if (process.env.NEXT_PUBLIC_CRM_BASE_PATH) {
    const basePath = process.env.NEXT_PUBLIC_CRM_BASE_PATH;
    if (basePath === "/") return "";
    return basePath.startsWith("/") ? basePath : `/${basePath}`;
  }

  if (process.env.NODE_ENV === "production" && typeof window === "undefined") {
    return "";
  }

  return "";
};

export const getFullPath = (path: string): string => {
  const basePath = getBasePath();
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${basePath}${cleanPath}`;
};

export const PATHS = {
  LOGIN: "/auth/login",
  LOGOUT: "/auth/logout",
  DASHBOARD: "/dashboard",
} as const;

export const getAuthPaths = () => {
  return {
    LOGIN_URL: PATHS.LOGIN,
    LOGOUT_URL: PATHS.LOGOUT,
    DASHBOARD_URL: PATHS.DASHBOARD,
  };
};

export const LOGIN_PAGE_URL = getAuthPaths()?.LOGIN_URL;

export const isBasePathRoute = (pathname: string): boolean => {
  const basePath = getBasePath();
  return pathname.startsWith(basePath) || pathname === basePath.slice(1);
};

export const normalizePathname = (pathname: string): string => {
  const basePath = getBasePath();
  if (pathname.startsWith(basePath)) return pathname;
  if (!pathname.startsWith("/")) return `${basePath}/${pathname}`;
  return `${basePath}${pathname}`;
};
